import { MappingField } from 'src/containers/ProjectDiagram/types/data';
import { MappingSuggestion } from 'src/containers/ProjectResourceSuggestionsDialog/projectResourceSuggestionsData';
import { IgnoredSuggestion } from 'src/containers/ProjectResourceSuggestionsDialog/utils/getOrganizedSuggestionRecords';

export enum EntityDrawerType {
  NONE = 'NONE',
  CLASS = 'CLASS',
  RELATIONSHIP = 'RELATIONSHIP',
  ATTRIBUTE = 'ATTRIBUTE',
  RESOURCE = 'RESOURCE',
  SENSITIVE_PROPERTY_GROUP = 'SENSITIVE_PROPERTY_GROUP',
}

export enum ProjectSortOption {
  NAME = 'Name',
  CREATED_AT = 'Created',
  UPDATED_AT = 'Updated',
}

type EntityDrawerExtraOptions = {
  isEditingAttributes?: boolean;
};

export type EntityDrawer = {
  entityValue?: string;
  type: EntityDrawerType;
} & EntityDrawerExtraOptions;

export type UiState = {
  filtersByProjectMapping: Record<
    string, // project id
    Record<
      string, // mapping id
      Record<
        string, // property iri
        boolean
      >
    >
  >;
  isCreateProjectDialogOpen: boolean;
  isProjectModelDialogOpen: boolean;
  isProjectModelDialogPendingOpen: boolean;
  isProjectResourceDialogOpen: boolean;
  isProjectResourceDialogPendingOpen: boolean;
  isProjectSettingsDrawerOpen: boolean;
  isPublishProjectDrawerOpen: boolean;
  isSignInDialogOpen: boolean;
  isVoiceboxDialogOpen: boolean;
  isVoiceboxDialogPendingOpen: boolean;
  createClassDrawer: {
    initialValue?: string;
    isOpen: boolean;
  };
  createRelationshipDrawer: {
    isOpen: boolean;
    sourceClassIri?: string;
    targetClassIri?: string;
  };
  createSensitivePropertyGroupDrawer: {
    isOpen: boolean;
    attributeIri?: string;
  };
  createMappingDialog: {
    initialValue?: string;
    isOpen: boolean;
    fromId?: string;
    fields?: Record<string, MappingField>;
    toValue?: string;
  };
  entityDrawer: EntityDrawer & {
    history: EntityDrawer[];
    projectId: string | null;
  };
  projectSortOption: ProjectSortOption;
  ruleDetailDrawer: {
    ruleId?: string;
    isOpen: boolean;
  };
  ruleOverviewDrawer: {
    isOpen: boolean;
  };
  fileUploadPreviewDialog: {
    isOpen: boolean;
    resourceId?: string;
  };
  resourceSuggestionsDialog: {
    initialClassIris?: string[];
    initialIgnoredSuggestions?: IgnoredSuggestion[];
    initialMappingSuggestions?: MappingSuggestion[];
    initialResourceIds?: string[];
    isOpen: boolean;
  };
  virtualGraphPreviewDialog: {
    isOpen: boolean;
    resourceId?: string;
  };
};

export const createInitialUiState = (): UiState => ({
  filtersByProjectMapping: {},
  isVoiceboxDialogOpen: false,
  isVoiceboxDialogPendingOpen: false,
  isCreateProjectDialogOpen: false,
  isProjectModelDialogOpen: false,
  isProjectModelDialogPendingOpen: false,
  isProjectResourceDialogOpen: false,
  isProjectResourceDialogPendingOpen: false,
  isProjectSettingsDrawerOpen: false,
  isPublishProjectDrawerOpen: false,
  isSignInDialogOpen: false,
  createClassDrawer: {
    isOpen: false,
  },
  createRelationshipDrawer: {
    isOpen: false,
  },
  createSensitivePropertyGroupDrawer: {
    isOpen: false,
  },
  createMappingDialog: {
    isOpen: false,
  },
  entityDrawer: {
    history: [],
    projectId: null,
    type: EntityDrawerType.NONE,
  },
  projectSortOption: ProjectSortOption.NAME,
  ruleDetailDrawer: {
    isOpen: false,
  },
  ruleOverviewDrawer: {
    isOpen: false,
  },
  fileUploadPreviewDialog: {
    isOpen: false,
  },
  resourceSuggestionsDialog: {
    isOpen: false,
  },
  virtualGraphPreviewDialog: {
    isOpen: false,
  },
});
